import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { KaizenSource, PagedResponseKaizenSource } from '../models/KaizenSource';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class KaizenSourceService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getKaizenSources():Observable<PagedResponseKaizenSource>{
    const data =  this.http.get<PagedResponseKaizenSource>(this.APIURL+'/KaizenSource' + '?PageNumber=1&PageSize=50');
    this.messageService.add('KaizenSource Service: fetched KaizenSource');
    return data;
  }

  getKaizenSource(id: number): Observable<KaizenSource> {
        const CostType =this.http.get<KaizenSource>(this.APIURL+'/KaizenSource/' + id);
    this.messageService.add(`KaizenSource Service: fetched KaizenSource with id=${id}`);
    return CostType;
  }
}